var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"camara"},[_c('video',{staticClass:"feed",attrs:{"autoplay":""}}),_c('button',{staticClass:"snap",on:{"click":function($event){return _vm.$emit('takePicture')}}},[_vm._v("SNAP")])])}
var staticRenderFns = []

export { render, staticRenderFns }